export const BUCKET_ISSUE_TYPES = {
    finish_inspection: [
        'unanswered_questions',
        'missing_signatures',
        'missing_deficiency_notes_photos',
        'missing_time_entries',
        'materials_services_incomplete',
        'analyze_deficiency_notes',
        'generate_description',
        'analyze_deficiency_photos'
    ],
    resolve_building_issues: [
        'unresolved_prior_deficiencies',
        'recurring_deficiencies',
        'out_of_spec_values',
        'drifting_values',
        'pump_curve_check'
    ],
    verify_inspection_data: ['asset_count_change', 'severity_discrepancy'],
    verify_code_requirements: ['ulc_reference_clause_check'],
    verify_inspection_activity: [
        'proximity_check',
        'inspection_timing_audit',
        'signature_quality_check',
        'duplicate_photo_detected'
    ],
    check_company_rules: ['custom_rule_finding']
};
